/** Joins CSS Module class names, skipping falsy entries. */
export const cx = (...names) => names.filter(Boolean).join(" ");
